"use strict";

const customCovers = require("./custom-covers/custom-covers-form.view");

module.exports = {
	customCovers,
};
